module.exports = __webpack_public_path__ + "img/close.7c3ed36a.png";